module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-10-4.3d8179e1.jpg";